/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-29 10:39:29
 * @FilePath: \app-client-h5\src\pages\orderList\index.jsx
 */
import React, { Component } from 'react';
import {
    Toast,
} from 'antd-mobile';
import { getCheckOrderList} from "./services";

import './index.scss'
class OrderList extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            emptyIcon:require('../../assets/empty.png'),
            orederList:[],
        }
    }

    getCheckOrderList = ()=>{
        getCheckOrderList().then((res) =>{
            if (res.code == '200') {
                this.setState({
                    orederList:res.data.list
                })
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            if (err.message){
                Toast.show({
                    content: err.message,
                })
            }else{
                Toast.show({
                    content: '系统错误',
                })
            }
        })
    }
    componentDidMount() {
        document.title = '我的买水订单'
        this.getCheckOrderList()
    }
    renderEmpty() {
        return (
            <div className="empty">
                <div>
                    <img className="emptyIcon" src = {this.state.emptyIcon}/>
                </div>
                <div className = 'text'>暂无数据</div>
            </div>
        )
    }
    render() {
        const {orederList}= this.state;
        return (
            <div className='orderList-container'>
                {!orederList&&this.renderEmpty()}
                {
                    orederList&&orederList.length>0&&orederList.map((item, index) =>{
                        return (
                            <div className='order-box' key={index}>
                                <div className = 'top'> 
                                    <span className = 'front'>买水量：<span className='value'>{item.waterNum}吨</span></span>
                                    {item.execStatus=="待执行到水表"&&<span className = 'right color-wait'>待执行到水表</span>}
                                    {item.execStatus=="执行中"&&<span className = 'right color-wait'>执行中</span>}
                                    {item.execStatus=="已执行到水表"&&<span className = 'right color-ok'>已执行到水表</span>}
                                    {item.execStatus=="执行失败"&&<span className = 'right color-fail'>执行失败</span>}
                                    {!item.execStatus&&<span className = 'right color-fail'>--</span>}
                                </div>
                                <div className="w_room">
                                    <span className = 'front'>充水房间：</span>
                                    <span className='value'>{item.projectName||'--'}<span className= 'verLine'>|</span>{(item.roomName)||'--'}</span>
                                </div>
                                <div>
                                    <span className = 'front'>订单号：</span>
                                    <span className='value'>{item.orderNo==null?'--':item.orderNo}</span>
                                </div>
                                <div>
                                    <span className = 'front'>支付方式：</span>
                                    <span className='value'>{item.payTypeName}</span>
                                </div>
                                <div className = 'time-box'>
                                    <span className = 'front'>订单时间：</span>
                                    <span className='value'>{item.createdTime==null?'--':item.createdTime}</span>
                                </div>
                                {item.responseTime?<div className = 'ztime-box'>
                                    <span className = 'front'>执行时间：</span>
                                    <span className='value'>{item.responseTime==null?'--':item.responseTime}</span>
                                </div>:''}
                                <div className = 'text-right'>
                                    <span className = 'symbol'>￥</span>
                                    <span className = 'number'>{item.amount}</span>
                                </div>
                            </div>
                        )
                    })
                }
                
            </div>
        )
    }
}
export default OrderList;

